import { FETCHING_LOCATIONS, RECEIVE_LOCATIONS, LOCATION_SAVED } from '../actions/LocationActions';

export const locations = (state = null, action) => {
  switch(action.type) {
    case FETCHING_LOCATIONS:
      return Object.assign({}, state, { fetching: true });
    case RECEIVE_LOCATIONS:
      return Object.assign({}, state, { fetching: false, list: action.locations });
    case LOCATION_SAVED:
      return Object.assign({}, state, { location: action.location });
    default:
      return state;
  }
}

export default locations;


// WEBPACK FOOTER //
// ./src/reducers/locations.js